export default `
query similarProducts($id: ID, $in_stock: Boolean) {
    product(id: $id) {
      id
      similar_products(in_stock: $in_stock) {
        activated_at
        id
        type
        title
        brand {
          id
          name
        }
        catalogue_photos(limit: 1) {
          medium_url
          full_url
        }
        category {
          id
          name
          accessory
        }
        member_price
        sale_price
        full_price
        swappable
      }
    }
  }  
`
